import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';

export const whatsappTemplates = pgTable('whatsapp_templates', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  key: text('key').notNull().unique(),
  description: text('description'),
  content: text('content').notNull(),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export type WhatsappTemplate = InferSelectModel<typeof whatsappTemplates>;
export type CreateWhatsappTemplateInput = InferInsertModel<typeof whatsappTemplates>;
export type UpdateWhatsappTemplateInput = Partial<CreateWhatsappTemplateInput>;
